import { useState } from "react";

const TEMPLATES = [
  { id: "user-welcome", group: "User", title: "Welcome mail", file: "/email-templates/user-welcome.html" },
  { id: "user-password-change", group: "User", title: "Password change", file: "/email-templates/user-password-change.html" },
  { id: "user-booking", group: "User", title: "Booking details", file: "/email-templates/user-booking.html" },
  { id: "user-session-cancelled", group: "User", title: "Session cancelled", file: "/email-templates/user-session-cancelled.html" },
  { id: "expert-application-submitted", group: "Expert", title: "Application submitted", file: "/email-templates/expert-application-submitted.html" },
  { id: "expert-application-approved", group: "Expert", title: "Application approved", file: "/email-templates/expert-application-approved.html" },
  { id: "expert-application-rejected", group: "Expert", title: "Application rejected", file: "/email-templates/expert-application-rejected.html" },
  { id: "expert-password-reset", group: "Expert", title: "Password reset", file: "/email-templates/expert-password-reset.html" },
  { id: "expert-booking", group: "Expert", title: "New booking", file: "/email-templates/expert-booking.html" },
  { id: "expert-session-change", group: "Expert", title: "Session rescheduled / cancelled", file: "/email-templates/expert-session-change.html" },
];

const EmailTemplatesPreview = () => {
  const [active, setActive] = useState(TEMPLATES[0]);

  return (
    <div className="min-h-screen bg-[#F8F8F8] text-[#2E2E2E]">
      <header className="border-b-2 border-[#5AC8FA] bg-white px-6 py-5">
        <h1 className="text-xl font-semibold text-[#864C90]">Soulversity Life Support — Email Templates</h1>
        <p className="text-sm text-muted-foreground mt-1">Preview all transactional email templates. Click any item to view it.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-0 min-h-[calc(100vh-89px)]">
        <aside className="border-r bg-white p-4 space-y-6">
          {(["User", "Expert"] as const).map((group) => (
            <div key={group}>
              <h2 className="text-xs uppercase tracking-wide font-semibold text-[#864C90] mb-2 px-2">{group} emails</h2>
              <ul className="space-y-1">
                {TEMPLATES.filter((t) => t.group === group).map((t) => (
                  <li key={t.id}>
                    <button
                      onClick={() => setActive(t)}
                      className={`w-full text-left px-3 py-2 rounded-md text-sm transition ${
                        active.id === t.id
                          ? "bg-[#864C90] text-white"
                          : "hover:bg-[#7DD8C9]/20 text-[#2E2E2E]"
                      }`}
                    >
                      {t.title}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </aside>

        <main className="p-4 md:p-6 space-y-4">
          <div className="flex items-center justify-between flex-wrap gap-3">
            <div>
              <div className="text-xs text-muted-foreground">{active.group} email</div>
              <div className="text-lg font-semibold">{active.title}</div>
            </div>
            <a
              href={active.file}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center px-4 py-2 rounded-md border border-[#864C90] text-[#864C90] text-sm hover:bg-[#864C90] hover:text-white transition"
            >
              Open in new tab ↗
            </a>
          </div>

          <div className="bg-white rounded-lg border overflow-hidden">
            <iframe
              key={active.id}
              src={active.file}
              title={active.title}
              className="w-full"
              style={{ height: "calc(100vh - 220px)", minHeight: 600, border: 0 }}
            />
          </div>
        </main>
      </div>
    </div>
  );
};

export default EmailTemplatesPreview;
